module.exports = __webpack_public_path__ + "static/img/product_03.93ca389.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_03.jpg
// module id = h14L
// module chunks = 2